/* Burini: Armá tu pack (mix & match). Sin dependencias.
   El descuento real lo aplica Shopify con un descuento automático; acá solo se muestra y se arma el carrito. */
(() => {
  if (customElements.get('burini-pack')) return;

  const STORAGE_KEY = 'burini-pack-v1';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const fmt = format || '${{amount}}';
    const withDelimiters = (number, precision, thousands, decimal) => {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      const n = (number / 100.0).toFixed(precision);
      const parts = n.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    };
    const match = fmt.match(placeholder);
    if (!match) return fmt;
    let value = '';
    switch (match[1]) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  const sizedUrl = (url, w, h) => {
    if (!url) return '';
    let u = String(url);
    if (u.startsWith('//')) u = 'https:' + u;
    const sep = u.includes('?') ? '&' : '?';
    return u + sep + 'width=' + w + (h ? '&height=' + h + '&crop=center' : '');
  };
  const norm = (s) => String(s || '').trim().toLowerCase();
  const escapeHtml = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const sizeSort = (a, b) => {
    const na = parseFloat(a), nb = parseFloat(b);
    if (!isNaN(na) && !isNaN(nb)) return na - nb;
    const order = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'];
    const ia = order.indexOf(norm(a)), ib = order.indexOf(norm(b));
    if (ia > -1 && ib > -1) return ia - ib;
    return String(a).localeCompare(String(b));
  };

  class BuriniPack extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try { this.config = JSON.parse(this.querySelector('[data-pack-config]').textContent); } catch (e) { this.config = {}; }
      this.strings = this.config.strings || {};
      this.packSize = parseInt(this.dataset.packSize, 10) || 3;
      this.discount = parseFloat(this.dataset.discount) || 0;
      this.sizeNames = (this.dataset.sizeNames || '').split(',').map(norm).filter(Boolean);
      this.colorNames = (this.dataset.colorNames || '').split(',').map(norm).filter(Boolean);
      this.swatchMap = this.parseSwatches(this.config.swatches || '');
      this.productCache = {};
      this.slots = this.loadState();
      this.activeSize = '';

      this.grid = this.querySelector('[data-grid]');
      this.sheet = this.querySelector('[data-sheet]');
      this.tray = this.querySelector('[data-tray]');
      this.cta = this.querySelector('[data-cta]');

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keyup', (e) => { if (e.key === 'Escape') this.closeSheet(); });
      this.buildFilterChips();
      this.render();
    }

    /* ---------- state ---------- */
    loadState() {
      try {
        const raw = sessionStorage.getItem(STORAGE_KEY + ':' + this.dataset.sectionId);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed.slice(0, this.packSize) : [];
      } catch (e) { return []; }
    }
    saveState() {
      try { sessionStorage.setItem(STORAGE_KEY + ':' + this.dataset.sectionId, JSON.stringify(this.slots)); } catch (e) { /* storage no disponible */ }
    }

    parseSwatches(html) {
      const map = {};
      String(html).split(/<\/p>\s*<p>|<p>|<\/p>/).forEach((line) => {
        const parts = line.split('=');
        if (parts.length >= 2) map[parts[0].trim()] = parts.slice(1).join('=').trim();
      });
      return map;
    }

    t(key, vars) {
      let s = this.strings[key] || '';
      Object.entries(vars || {}).forEach(([k, v]) => { s = s.split('[' + k + ']').join(v); });
      return s.split('[discount]').join(String(this.discount)).split('[size]').join(String(this.packSize));
    }
    money(cents) { return formatMoney(Math.round(cents), this.config.moneyFormat); }

    /* ---------- events ---------- */
    onClick(e) {
      const open = e.target.closest('[data-open]');
      if (open) { e.preventDefault(); this.openSheet(open.dataset.handle); return; }
      if (e.target.closest('[data-sheet-close]')) { this.closeSheet(); return; }
      if (e.target.closest('[data-sheet-add]')) { this.addFromSheet(); return; }
      const chip = e.target.closest('[data-size]');
      if (chip && chip.closest('[data-filter-chips]')) { this.setFilter(chip.dataset.size); return; }
      const more = e.target.closest('[data-more]');
      if (more) { this.loadMore(more); return; }
      const slot = e.target.closest('[data-slot]');
      if (slot) { this.onSlot(parseInt(slot.dataset.slot, 10)); return; }
      const remove = e.target.closest('[data-remove]');
      if (remove) { this.removeSlot(parseInt(remove.dataset.remove, 10)); return; }
      if (e.target.closest('[data-cta]')) { this.addPackToCart(); }
    }

    onSlot(index) {
      if (this.slots[index]) {
        const list = this.querySelector('[data-tray-list]');
        list.hidden = !list.hidden;
      } else if (this.grid) {
        this.grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    removeSlot(index) {
      this.slots.splice(index, 1);
      this.saveState();
      this.render();
      if (!this.slots.length) this.querySelector('[data-tray-list]').hidden = true;
    }

    /* ---------- filter & pagination ---------- */
    buildFilterChips() {
      const wrap = this.querySelector('[data-filter-chips]');
      if (!wrap || !this.grid) return;
      const set = new Set();
      this.grid.querySelectorAll('[data-card]').forEach((c) => c.dataset.sizes.split('|').filter(Boolean).forEach((s) => set.add(s)));
      const sizes = Array.from(set).sort(sizeSort);
      const existing = Array.from(wrap.querySelectorAll('[data-size]')).map((b) => b.dataset.size);
      sizes.forEach((s) => {
        if (existing.includes(s)) return;
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'bpack__chip';
        b.dataset.size = s;
        b.textContent = s;
        wrap.appendChild(b);
      });
      const chips = Array.from(wrap.querySelectorAll('[data-size]')).filter((b) => b.dataset.size);
      chips.sort((a, b) => sizeSort(a.dataset.size, b.dataset.size)).forEach((b) => wrap.appendChild(b));
    }

    setFilter(size) {
      this.activeSize = size;
      this.querySelectorAll('[data-filter-chips] [data-size]').forEach((b) => {
        const on = b.dataset.size === size;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.applyFilter();
      if (size) this.loadAllPages();
    }

    applyFilter() {
      if (!this.grid) return;
      this.grid.querySelectorAll('[data-card]').forEach((c) => {
        c.hidden = !!this.activeSize && !c.dataset.sizes.includes('|' + this.activeSize + '|');
      });
    }

    async fetchPage(url) {
      const sep = url.includes('?') ? '&' : '?';
      const res = await fetch(url + sep + 'section_id=' + encodeURIComponent(this.dataset.sectionId));
      if (!res.ok) throw new Error('page');
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      return {
        cards: Array.from(doc.querySelectorAll('[data-grid] > [data-card]')),
        next: doc.querySelector('[data-more]') ? doc.querySelector('[data-more]').dataset.nextUrl : ''
      };
    }

    async loadMore(btn) {
      if (this._loading) return;
      this._loading = true;
      btn.setAttribute('aria-busy', 'true');
      try {
        const { cards, next } = await this.fetchPage(btn.dataset.nextUrl);
        const known = new Set(Array.from(this.grid.querySelectorAll('[data-card]')).map((c) => c.dataset.handle));
        cards.forEach((c) => { if (!known.has(c.dataset.handle)) this.grid.appendChild(document.importNode(c, true)); });
        if (next) btn.dataset.nextUrl = next; else this.querySelector('[data-more-wrap]').remove();
        this.buildFilterChips();
        this.applyFilter();
        this.renderCardBadges();
      } catch (e) { /* se puede reintentar con el botón */ }
      btn.removeAttribute('aria-busy');
      this._loading = false;
    }

    async loadAllPages() {
      let btn = this.querySelector('[data-more]');
      let guard = 0;
      while (btn && guard < 20) {
        guard += 1;
        await this.loadMore(btn);
        btn = this.querySelector('[data-more]');
      }
    }

    /* ---------- sheet ---------- */
    async getProduct(handle) {
      if (this.productCache[handle]) return this.productCache[handle];
      const res = await fetch((this.config.root || '/').replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '.js');
      if (!res.ok) throw new Error('product');
      const p = await res.json();
      this.productCache[handle] = p;
      return p;
    }

    findOptionIndex(product, names) {
      return (product.options || []).findIndex((o) => names.includes(norm(o.name || o)));
    }

    async openSheet(handle) {
      this._lastFocus = document.activeElement;
      this.sheet.hidden = false;
      document.body.classList.add('bpack-lock');
      requestAnimationFrame(() => this.sheet.classList.add('is-open'));
      const body = this.querySelector('[data-sheet-body]');
      body.setAttribute('aria-busy', 'true');
      this.setSheetError('');
      try {
        const product = await this.getProduct(handle);
        this.current = { product, selection: [] };
        this.colorIdx = this.findOptionIndex(product, this.colorNames);
        this.sizeIdx = this.findOptionIndex(product, this.sizeNames);
        const first = product.variants.find((v) => v.available) || product.variants[0];
        this.current.selection = first.options.slice();
        if (this.sizeIdx > -1 && this.activeSize) {
          const withSize = product.variants.find((v) => v.available && v.options[this.sizeIdx] === this.activeSize);
          if (withSize) this.current.selection = withSize.options.slice();
        }
        this.renderSheet();
      } catch (e) {
        this.setSheetError(this.t('error'));
      }
      body.removeAttribute('aria-busy');
      const close = this.querySelector('.bpack__sheet-close');
      if (close) close.focus();
    }

    closeSheet() {
      if (this.sheet.hidden) return;
      this.sheet.classList.remove('is-open');
      document.body.classList.remove('bpack-lock');
      setTimeout(() => { this.sheet.hidden = true; }, 200);
      if (this._lastFocus && this._lastFocus.focus) this._lastFocus.focus();
    }

    setSheetError(msg) {
      const el = this.querySelector('[data-sheet-error]');
      el.textContent = msg;
      el.hidden = !msg;
    }

    currentVariant() {
      const { product, selection } = this.current;
      return product.variants.find((v) => v.options.every((o, i) => o === selection[i]));
    }

    isValueAvailable(optIdx, value) {
      const { product, selection } = this.current;
      return product.variants.some((v) => v.available && v.options[optIdx] === value &&
        v.options.every((o, i) => i === optIdx || i > optIdx || o === selection[i]));
    }

    variantImageFor(optIdx, value) {
      const v = this.current.product.variants.find((x) => x.options[optIdx] === value && x.featured_image);
      return v ? v.featured_image.src : '';
    }

    renderSheet() {
      const { product, selection } = this.current;
      const variant = this.currentVariant();
      const img = this.querySelector('[data-sheet-img]');
      const src = (variant && variant.featured_image && variant.featured_image.src) || product.featured_image || '';
      img.src = sizedUrl(src, 240);
      img.alt = product.title;
      this.querySelector('[data-sheet-title]').textContent = product.title;
      this.querySelector('[data-sheet-price]').textContent = this.money(variant ? variant.price : product.price);
      this.querySelector('[data-sheet-link]').href = product.url;

      const colorWrap = this.querySelector('[data-opt-color]');
      const sizeWrap = this.querySelector('[data-opt-size]');
      const otherWrap = this.querySelector('[data-opt-other]');
      otherWrap.innerHTML = '';

      product.options.forEach((opt, idx) => {
        const name = opt.name || opt;
        const values = opt.values || [];
        if (values.length === 1 && values[0] === 'Default Title') return;
        if (idx === this.colorIdx) {
          colorWrap.hidden = false;
          colorWrap.querySelector('[data-color-name]').textContent = name;
          colorWrap.querySelector('[data-color-value]').textContent = selection[idx] || '';
          colorWrap.querySelector('[data-color-list]').innerHTML = values.map((val) => {
            const avail = this.isValueAvailable(idx, val);
            const hex = this.swatchMap[val];
            const vimg = !hex ? this.variantImageFor(idx, val) : '';
            const style = hex ? `background:${escapeHtml(hex)}` : (vimg ? `background-image:url('${escapeHtml(sizedUrl(vimg, 80, 80))}')` : '');
            const label = !hex && !vimg ? `<span class="bpack__swatch-text">${escapeHtml(val.slice(0, 2))}</span>` : '';
            return `<button type="button" role="radio" class="bpack__swatch${selection[idx] === val ? ' is-selected' : ''}${avail ? '' : ' is-unavailable'}" aria-checked="${selection[idx] === val}" aria-label="${escapeHtml(val)}" title="${escapeHtml(val)}" data-opt="${idx}" data-val="${escapeHtml(val)}" style="${style}">${label}</button>`;
          }).join('');
        } else {
          const isSize = idx === this.sizeIdx;
          const wrap = isSize ? sizeWrap : otherWrap;
          let listEl;
          if (isSize) {
            sizeWrap.hidden = false;
            sizeWrap.querySelector('[data-size-name]').textContent = name;
            sizeWrap.querySelector('[data-size-value]').textContent = selection[idx] || '';
            listEl = sizeWrap.querySelector('[data-size-list]');
          } else {
            const block = document.createElement('div');
            block.innerHTML = `<p class="bpack__opt-label">${escapeHtml(name)}: <strong>${escapeHtml(selection[idx] || '')}</strong></p><div class="bpack__sizes" role="radiogroup"></div>`;
            wrap.appendChild(block);
            listEl = block.querySelector('.bpack__sizes');
          }
          listEl.innerHTML = values.map((val) => {
            const avail = this.isValueAvailable(idx, val);
            return `<button type="button" role="radio" class="bpack__pill${selection[idx] === val ? ' is-selected' : ''}${avail ? '' : ' is-unavailable'}" aria-checked="${selection[idx] === val}" data-opt="${idx}" data-val="${escapeHtml(val)}"${avail ? '' : ' aria-disabled="true"'}>${escapeHtml(val)}</button>`;
          }).join('');
        }
      });
      if (this.colorIdx < 0) colorWrap.hidden = true;
      if (this.sizeIdx < 0) sizeWrap.hidden = true;

      this.querySelectorAll('[data-sheet-body] [data-opt]').forEach((b) => {
        b.onclick = () => this.selectOption(parseInt(b.dataset.opt, 10), b.dataset.val);
      });

      const addBtn = this.querySelector('[data-sheet-add]');
      const full = this.slots.length >= this.packSize;
      const ok = variant && variant.available && !full;
      addBtn.disabled = !ok;
      if (full) this.setSheetError(this.t('packFull'));
      else if (!variant || !variant.available) this.setSheetError(this.t('unavailable'));
      else this.setSheetError('');
    }

    selectOption(idx, value) {
      const { product } = this.current;
      const sel = this.current.selection.slice();
      sel[idx] = value;
      // si la combinación no existe o no hay stock, buscar la más cercana disponible con este valor
      let match = product.variants.find((v) => v.available && v.options.every((o, i) => o === sel[i]));
      if (!match) {
        match = product.variants.find((v) => v.available && v.options[idx] === value &&
          v.options.every((o, i) => i <= idx ? (i === idx || o === sel[i]) : true));
      }
      this.current.selection = match ? match.options.slice() : sel;
      this.renderSheet();
    }

    addFromSheet() {
      const variant = this.currentVariant();
      if (!variant || !variant.available) return;
      if (this.slots.length >= this.packSize) { this.setSheetError(this.t('packFull')); return; }
      const { product } = this.current;
      const img = (variant.featured_image && variant.featured_image.src) || product.featured_image || '';
      this.slots.push({
        id: variant.id,
        handle: product.handle,
        title: product.title,
        variantTitle: variant.public_title || variant.title,
        price: variant.price,
        image: img
      });
      this.saveState();
      this.closeSheet();
      this.render();
      this.tray.classList.remove('is-bump');
      void this.tray.offsetWidth;
      this.tray.classList.add('is-bump');
    }

    /* ---------- render tray ---------- */
    totals() {
      const subtotal = this.slots.reduce((s, x) => s + x.price, 0);
      const complete = this.slots.length >= this.packSize;
      const total = complete ? Math.round(subtotal * (100 - this.discount) / 100) : subtotal;
      return { subtotal, total, saving: subtotal - total, complete };
    }

    render() {
      const slotsEls = this.querySelectorAll('[data-slot]');
      slotsEls.forEach((el, i) => {
        const s = this.slots[i];
        el.classList.toggle('is-filled', !!s);
        el.innerHTML = s && s.image ? `<img src="${escapeHtml(sizedUrl(s.image, 120, 120))}" alt="" width="60" height="60">` : '';
        if (!el.dataset.emptyLabel) el.dataset.emptyLabel = el.getAttribute('aria-label') || '';
        el.setAttribute('aria-label', s ? `${s.title} · ${s.variantTitle}` : el.dataset.emptyLabel);
      });

      const { subtotal, total, saving, complete } = this.totals();
      const remaining = this.packSize - this.slots.length;
      this.querySelector('[data-status]').textContent = complete ? this.t('complete') : this.t('remaining', { n: remaining });
      this.querySelector('[data-total]').innerHTML = !this.slots.length ? '' : complete
        ? `<s>${this.money(subtotal)}</s> <strong>${this.money(total)}</strong> <span class="bpack__save">${escapeHtml(this.t('save'))} ${this.money(saving)}</span>`
        : `<strong>${this.money(subtotal)}</strong>`;
      this.cta.disabled = !complete;
      this.tray.classList.toggle('is-complete', complete);
      this.tray.classList.toggle('has-items', this.slots.length > 0);

      this.querySelector('[data-tray-list]').innerHTML = this.slots.map((s, i) => `
        <div class="bpack__tray-item">
          ${s.image ? `<img src="${escapeHtml(sizedUrl(s.image, 120, 150))}" alt="" width="40" height="50">` : ''}
          <div class="bpack__tray-item-info"><span>${escapeHtml(s.title)}</span><small>${escapeHtml(s.variantTitle)} · ${this.money(s.price)}</small></div>
          <button type="button" class="bpack__tray-remove" data-remove="${i}">${escapeHtml(this.t('remove'))}</button>
        </div>`).join('');

      this.renderCardBadges();
    }

    renderCardBadges() {
      const counts = {};
      this.slots.forEach((s) => { counts[s.handle] = (counts[s.handle] || 0) + 1; });
      this.querySelectorAll('[data-card]').forEach((c) => {
        const n = counts[c.dataset.handle] || 0;
        const badge = c.querySelector('[data-count]');
        c.classList.toggle('is-in-pack', n > 0);
        if (badge) { badge.hidden = !n; badge.textContent = n > 1 ? `${this.t('inPack')} ×${n}` : this.t('inPack'); }
      });
    }

    /* ---------- cart ---------- */
    async addPackToCart() {
      if (this.slots.length < this.packSize || this._adding) return;
      this._adding = true;
      this.cta.setAttribute('aria-busy', 'true');
      this.cta.classList.add('loading');
      const spinner = this.querySelector('[data-cta-spinner]');
      if (spinner) spinner.classList.remove('hidden');

      const packId = (this.dataset.packLabel || 'Pack') + ' #' + Date.now().toString(36).toUpperCase();
      const cartDrawer = document.querySelector('cart-drawer');
      const body = {
        items: this.slots.map((s) => ({ id: s.id, quantity: 1, properties: { _pack: packId } }))
      };
      if (cartDrawer && cartDrawer.getSectionsToRender) {
        body.sections = cartDrawer.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }
      try {
        const res = await fetch((this.config.cartAddUrl || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'cart');
        this.slots = [];
        this.saveState();
        this.render();
        this.querySelector('[data-tray-list]').hidden = true;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'burini-pack', cartData: data });
        }
        if (cartDrawer && data.sections) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(data);
        } else {
          window.location = this.config.cartUrl || '/cart';
        }
      } catch (e) {
        const status = this.querySelector('[data-status]');
        status.textContent = e && e.message && e.message !== 'cart' ? e.message : this.t('error');
      }
      if (spinner) spinner.classList.add('hidden');
      this.cta.classList.remove('loading');
      this.cta.removeAttribute('aria-busy');
      this._adding = false;
    }
  }

  customElements.define('burini-pack', BuriniPack);
})();
